export default "__VITE_ASSET__BuLYQh_6__"